import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LanguageDataService } from './language-data.service';


export class CustomLoader implements TranslateLoader {
    constructor(private commonLocalizationService: LanguageDataService) { }
    a:Observable<any>
    getTranslation(lang: string): Observable<any> {
        return this.commonLocalizationService.getLocalizationData(lang) as Observable<any>;
    }
}
